import React, { useState, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import styles from "../styles/NewDiscussionPage.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCommentDots } from "@fortawesome/free-solid-svg-icons";
import ReactMarkdown from "react-markdown";
import { AuthContext } from "../AuthProvider";
import { createDiscussion, createComment } from "../api/api";

const NewDiscussionPage = () => {
  const { id } = useParams();
  const { keycloak, authenticated } = useContext(AuthContext);
  const navigate = useNavigate();
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [activeTab, setActiveTab] = useState("Edit");

  const handleCancel = () => {
    window.history.back();
  };

  const handleSubmit = () => {
    if (authenticated) {
      if (!title.trim() || !description.trim()) {
        alert("Title and Description are required.");
        return;
      }

      const createNewDiscussion = async () => {
        try {
          const response = await createDiscussion(keycloak.token, {
            file_id: id,
            title: title,
          });
          const discussionId = response.id;
          await createComment(keycloak.token, {
            discussion_id: discussionId,
            content: description,
          });
          navigate(`/workflow/${id}/community/${discussionId}`);
        } catch (error) {
          console.error("Error creating discussion:", error);
        }
      };

      createNewDiscussion();
    } else {
      console.error("User not authenticated.");
    }
  };

  return (
    <div className={styles.newDiscussionPage}>
      {/* Row 1: New Discussion */}
      <div className={styles.header}>
        <FontAwesomeIcon icon={faCommentDots} className={styles.icon} />
        <h1>New Discussion</h1>
      </div>

      {/* Row 2: Title Container */}
      <div className={styles.titleContainer}>
        <h2>Title</h2>
        <input
          type="text"
          placeholder="Enter the discussion title..."
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          className={styles.titleInput}
        />
      </div>

      {/* Row 3: Message Container */}
      <div className={styles.messageContainer}>
        <h2>Description</h2>

        {/* Tabs */}
        <div className={styles.tabs}>
          <button
            className={`${styles.tabButton} ${
              activeTab === "Edit" ? styles.activeTab : ""
            }`}
            onClick={() => setActiveTab("Edit")}
          >
            Edit
          </button>
          <button
            className={`${styles.tabButton} ${
              activeTab === "Preview" ? styles.activeTab : ""
            }`}
            onClick={() => setActiveTab("Preview")}
          >
            Preview
          </button>
        </div>

        {/* Description Input or Preview */}
        <div className={styles.tabContent}>
          {activeTab === "Edit" ? (
            <textarea
              className={styles.textarea}
              placeholder="Write your description here..."
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          ) : (
            <div className={styles.preview}>
              <ReactMarkdown>
                {description || "Nothing to preview yet."}
              </ReactMarkdown>
            </div>
          )}
        </div>

        {/* Buttons */}
        <div className={styles.actionButtons}>
          <button className={styles.cancelButton} onClick={handleCancel}>
            Cancel
          </button>
          <button
            className={styles.submitButton}
            onClick={handleSubmit}
            disabled={!title.trim() || !description.trim()}
          >
            Create Discussion
          </button>
        </div>
      </div>
    </div>
  );
};

export default NewDiscussionPage;
